import React, { useState, useEffect } from 'react';
import SiteLayout from '../../layouts/SiteLayout';
import Header from '../../components/Header/Header';
import { useAuth } from '../../context/AuthContext';
import { API_URL } from '../../config';
import useScreenType from '../../hooks/useScreenType';

// Views
import DesktopLeaderboard from './DesktopLeaderboard';
import MobileLeaderboard from './MobileLeaderboard';

interface LeaderboardEntry {
    rank: number | null;
    pseudonym: string | null;
    twr_performance: number;
    calculated_at: string;
}

const LeaderboardScreen: React.FC = () => {
    const { token, user } = useAuth();
    const { isMobile, isTablet } = useScreenType();
    const useMobileLayout = isMobile || isTablet;

    const [activeTab, setActiveTab] = useState<'LOCAL' | 'GLOBAL'>('LOCAL');
    const [period, setPeriod] = useState<'TODAY' | 'WEEKLY' | 'MONTHLY' | 'LAST_MONTH' | 'YTD'>('YTD');
    const [loading, setLoading] = useState(false);
    const [localData, setLocalData] = useState<any[]>([]);
    const [globalData, setGlobalData] = useState<LeaderboardEntry[]>([]);
    const [myRank, setMyRank] = useState<{ rank: number | null; twr_performance: number | null; pseudonym: string | null; exclusion: string | null } | null>(null);

    useEffect(() => {
        fetchData();
    }, [activeTab]);

    useEffect(() => {
        fetchData();
    }, [period]);

    const fetchData = async () => {
        setLoading(true);
        try {
            // my-rank sur les deux onglets : il porte aussi le motif d'une exclusion,
            // à afficher en local comme en global plutôt qu'un classement vide.
            const tableUrl = activeTab === 'LOCAL'
                ? `${API_URL}/v1/social/leaderboard/local?period=${period}`
                : `${API_URL}/v1/social/leaderboard/global?period=${period}`;
            const [tableRes, myRankRes] = await Promise.all([
                fetch(tableUrl, { headers: { Authorization: `Bearer ${token}` } }),
                fetch(`${API_URL}/v1/social/leaderboard/my-rank?period=${period}`, {
                    headers: { Authorization: `Bearer ${token}` }
                })
            ]);
            if (tableRes.ok) {
                const data = await tableRes.json();
                if (activeTab === 'LOCAL') setLocalData(data);
                else setGlobalData(data);
            }
            setMyRank(myRankRes.ok ? await myRankRes.json() : null);
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    const hasOptedIn = !!user?.social_profile?.is_opt_in_leaderboard;

    const childProps = {
        activeTab,
        setActiveTab,
        period,
        setPeriod,
        loading,
        localData,
        globalData,
        myRank,
        hasOptedIn,
        user
    };

    return (
        <SiteLayout>
            <Header icon='emoji_events' title='Leaderboard' />
            {useMobileLayout ? (
                <MobileLeaderboard {...childProps} />
            ) : (
                <DesktopLeaderboard {...childProps} />
            )}
        </SiteLayout>
    );
};

export default LeaderboardScreen;

